import React from "react";
import { Grid, Menu, Segment } from "semantic-ui-react";
import { Outlet, NavLink } from "react-router-dom";
import { PRODUCT_PERMISSIONS, USER_PERMISSIONS } from 'dyl-components';
import RestrictedView from "shared/RestrictedView";

const Library = ({ generateTabProperties }) => {
    return (
        <React.Fragment>
            <Menu borderless pointing secondary color={"primary"} stackable>
                <RestrictedView type='disabled' userPermission={USER_PERMISSIONS.LIBRARY_VIEW}>
                    <Menu.Item {...generateTabProperties("Text Templates")} />
                </RestrictedView>
                <RestrictedView type='disabled' userPermission={USER_PERMISSIONS.LIBRARY_VIEW}>
                    <Menu.Item {...generateTabProperties("Email Templates")} />
                </RestrictedView>
                <RestrictedView type='disabled' productPermission={PRODUCT_PERMISSIONS.SETTINGS_DIALER_SCRIPTS} userPermission={USER_PERMISSIONS.LIBRARY_VIEW}>
                    <Menu.Item {...generateTabProperties("Dialer Scripts")} />
                </RestrictedView>
                <RestrictedView type='disabled' userPermission={USER_PERMISSIONS.LIBRARY_VIEW}>
                    <Menu.Item {...generateTabProperties("Task Types")} />
                </RestrictedView>
                <RestrictedView type="disabled" productPermission={PRODUCT_PERMISSIONS.SETTINGS_CALL_TAGS} userPermission={USER_PERMISSIONS.LIBRARY_VIEW}>
                    <Menu.Item {...generateTabProperties("Call Tags")} />
                </RestrictedView>
            </Menu>
            <Segment basic>
            <Outlet />
            </Segment>
        </React.Fragment>
    );
};

class LibraryContainer extends React.Component {
    generateTabProperties = item => {
        const formatted_item = item.split(" ").join("-").toLowerCase();
        return {
            name: item,
            as: NavLink,
            to: formatted_item
        };
    };

    render() {
        return (
            <Grid>
                <Grid.Row style={{ marginTop: 0, borderRadius: 0 }}>
                    <Grid.Column>
                        <Library
                            generateTabProperties={this.generateTabProperties}
                        />
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        );
    }
}

export default LibraryContainer;
